import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page">
      <Nav />
      <section className="mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 py-40 text-center">
        <XCircle size={48} className="text-mute" />
        <h1 className="mt-8 font-display text-4xl text-ivory md:text-5xl">Pagamento annullato.</h1>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-mute md:text-base">
          Nessun addebito è stato effettuato. Puoi riprovare quando vuoi: il percorso ti aspetta.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/pacchetti" data-testid="cancel-back-packages" className="btn-primary">Torna ai pacchetti</Link>
          <Link to="/contatti" data-testid="cancel-back-guides" className="btn-outline">Contattami</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
